import React  from 'react';

import HealthDetailsContent from "../content/HealthDetailsContent";

import Navbar from "../inc/Navbar";
import Footer from "../inc/Footer";

function HealthDetails() {
    return(
        <>
        <Navbar />
        <HealthDetailsContent/>
        <Footer />        
        </>
    );
}

export default HealthDetails;